class r extends Error{constructor(r,e){super(r),this.name="SyntheticChangeError",this.cause=e}}export{r as default};
